import { Component, OnDestroy, Renderer2 } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

/** Body class for /cp UI styles (um-table, um-toolbar, typography). */
export const PV_ADMIN_UI_CLASS = 'pv-admin-ui';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent implements OnDestroy {
  private readonly routerSub: Subscription;

  constructor(private router: Router, private renderer: Renderer2) {
    this.syncPvAdminUiClass(this.router.url);

    this.routerSub = this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe(event => {
        localStorage.setItem('siteSearchFilterVal', '');
        localStorage.setItem('cameraSearchFilterVal', '');
        (<any>window).ga('set', 'page', event.urlAfterRedirects);
        (<any>window).ga('send', 'pageview');
        this.syncPvAdminUiClass(event.urlAfterRedirects);
      });
  }

  ngOnDestroy(): void {
    this.routerSub?.unsubscribe();
  }

  private syncPvAdminUiClass(url: string): void {
    const path = (url || '').split('?')[0].split('#')[0];
    const isCpUi = path === '/cp' || path.startsWith('/cp/');
    if (isCpUi) {
      this.renderer.addClass(document.body, PV_ADMIN_UI_CLASS);
    } else {
      this.renderer.removeClass(document.body, PV_ADMIN_UI_CLASS);
    }
  }
}
